import React from "react";
import { useIntl } from "react-intl";

import { parseRRULE } from "../../util/helpers.js";
import PeriodicityIcon from "../../modules/periodicity-icon/PeriodicityIcon.jsx";

const PeriodicityComponent = ({
  periodicity,
  editable,
  onPeriodicityClick,
  position,
}) => {
  const intl = useIntl();
  const parsedPeriodicity = periodicity ? parseRRULE(periodicity) : null;
  const handleClick = (event) => {
    event.stopPropagation();
    if (editable && onPeriodicityClick) {
      onPeriodicityClick();
    }
  };

  const className = position ? `${position}-periodicity` : "periodicity";

  if (position === "catalog") return <></>;
  return (
    <div
      className={className}
      {...(onPeriodicityClick ? { onClick: handleClick } : {})}
    >
      {parsedPeriodicity && parsedPeriodicity.interval ? (
        <PeriodicityIcon
          interval={parsedPeriodicity.interval}
          editable={editable}
        />
      ) : (
        <PeriodicityIcon interval={"E"} editable={editable} />
      )}
    </div>
  );
};

export default PeriodicityComponent;
